// Pure derived selectors over API data — shared by pages/components.

import type { Alert, AccountRow } from '../types/api';

/** An alert is "active" while pending or firing (not yet acknowledged/resolved). */
export function isActiveAlert(a: Alert): boolean {
  return a.state === 'pending' || a.state === 'firing';
}

export function activeAlerts(alerts: Alert[]): Alert[] {
  return alerts.filter(isActiveAlert);
}

export function activeCriticalCount(alerts: Alert[]): number {
  let n = 0;
  for (const a of alerts) if (a.severity === 'critical' && isActiveAlert(a)) n++;
  return n;
}

/** Alerts attached to a specific account, newest started first. */
export function alertsForAccount(alerts: Alert[], accountId: string): Alert[] {
  return alerts
    .filter((a) => a.account_id === accountId)
    .slice()
    .sort((p, q) => Date.parse(q.started_at) - Date.parse(p.started_at));
}

export function accountById(accounts: AccountRow[], id: string): AccountRow | undefined {
  return accounts.find((a) => a.id === id);
}
